import ComponentName from '@Constant/componentName'

const home = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/qualification',
    // redirect: {
    //   name: ComponentName.qualification.index
    // },
    children: [
      {
        component: () => import('../../views/qualification/Index.vue'),
        path: 'index',
        name: ComponentName.qualification.index,
        auth: '*',
        meta: {
          title: '资质信息'
        }
      },
      {
        component: () => import('../../views/qualification/BaseInform.vue'),
        path: 'base',
        name: ComponentName.qualification.base,
        auth: '*',
        meta: {
          title: '基础信息'
        }
      },
      {
        component: () => import('../../views/qualification/role/Index.vue'),
        path: 'role',
        name: ComponentName.qualification.role,
        auth: '*',
        meta: {
          title: '企业认证'
        }
      },
      {
        component: () => import('../../views/qualification/industry/Index.vue'),
        path: 'industry',
        name: ComponentName.qualification.industry,
        auth: '*',
        meta: {
          title: '行业认证'
        }
      },
      {
        component: () => import('../../views/qualification/supplement/Index.vue'),
        path: 'supply',
        name: ComponentName.qualification.supplementary,
        auth: '*',
        props: true,
        meta: {
          title: '投放补充'
        }
      }
    ]
  }
]

export default home
